/**
 * Settings Privacy - AJAX Field Handler
 * Handles automatic saving of privacy settings when fields are changed
 *
 * @author InterPals Development Team
 * @version 1.0.0
 */

(function() {
    'use strict';

    // Helper to get translation (falls back to key if i18n not available)
    function t(key) {
        return window.t ? window.t(key) : key;
    }

    // Only run on settings pages with privacy section
    var isSettingsPage = window.location.pathname.includes('/settings');
    var isPrivacySection = window.location.search.includes('section=privacy');

    if (!isSettingsPage || !isPrivacySection) {
        return;
    }

    // Use shared helpers
    var helpers = window.SettingsHelpers;
    if (!helpers) {
        console.error('SettingsHelpers not loaded');
        return;
    }

    var REQUEST_TIMEOUT = 10000; // 10 seconds

    var CSS_CLASSES = {
        AJAX_SELECT: 'ajax-privacy-select',
        AJAX_SWITCH: 'ajax-privacy-switch'
    };

    /**
     * Handle select field change with AJAX
     * @param {HTMLSelectElement} select - The select element
     */
    function handleSelectChange(select) {
        var fieldName = select.getAttribute('data-field');
        var spinnerElement = document.getElementById(fieldName + '-spinner');
        var container = select.closest('.privacy-setting-row') || select.closest('.privacy-card');

        if (!fieldName) {
            return;
        }

        var newValue = select.value;
        var originalValue = select.getAttribute('data-original-value') || newValue;

        helpers.sendFieldUpdate({
            fieldName: fieldName,
            fieldValue: newValue,
            container: container,
            field: select,
            spinner: spinnerElement,
            timeout: REQUEST_TIMEOUT,
            onSuccess: function(data) {
                // Update original value
                select.setAttribute('data-original-value', data.value);
            },
            onError: function() {
                // Revert to original value
                select.value = originalValue;
            }
        });
    }

    /**
     * Update status badge appearance based on checked state
     * @param {HTMLElement} badge - The status badge element
     * @param {boolean} isChecked - Whether the switch is checked
     */
    function updateStatusBadge(badge, isChecked) {
        if (!badge) return;

        badge.classList.remove('bg-green-100', 'text-green-700', 'bg-gray-100', 'text-gray-600');

        if (isChecked) {
            badge.classList.add('bg-green-100', 'text-green-700');
            badge.textContent = t('common.privacy_visible');
        } else {
            badge.classList.add('bg-gray-100', 'text-gray-600');
            badge.textContent = t('common.privacy_hidden');
        }
    }

    /**
     * Handle switch toggle change with AJAX
     * @param {HTMLInputElement} switchInput - The switch input element
     */
    function handleSwitchChange(switchInput) {
        var fieldName = switchInput.getAttribute('data-field');
        var spinnerElement = document.getElementById(fieldName + '-spinner');
        var container = switchInput.closest('.privacy-setting-row') || switchInput.closest('.privacy-card');

        if (!fieldName) {
            return;
        }

        var newState = switchInput.checked;
        var originalState = !newState;
        var statusBadge = container ? container.querySelector('.status-badge') : null;

        helpers.sendFieldUpdate({
            fieldName: fieldName,
            fieldValue: newState ? '1' : '0',
            container: container,
            field: switchInput,
            spinner: spinnerElement,
            timeout: REQUEST_TIMEOUT,
            onSuccess: function(data) {
                // Ensure state matches server response
                var finalState = Boolean(parseInt(data.value));
                switchInput.checked = finalState;
                updateStatusBadge(statusBadge, finalState);
            },
            onError: function() {
                // Revert state on error
                switchInput.checked = originalState;
                updateStatusBadge(statusBadge, originalState);
            }
        });
    }

    /**
     * Initialize AJAX privacy field handlers
     */
    function initPrivacyFields() {
        // Initialize hidden inputs with original values
        var ajaxSelects = document.querySelectorAll('.' + CSS_CLASSES.AJAX_SELECT);
        ajaxSelects.forEach(function(select) {
            // Store original value
            select.setAttribute('data-original-value', select.value);
        });

        // Listen for inline select change events on each container
        var inlineSelectContainers = document.querySelectorAll('.inline-select-container');
        inlineSelectContainers.forEach(function(container) {
            container.addEventListener('inlineSelectChange', function() {
                var hiddenInput = container.querySelector('.' + CSS_CLASSES.AJAX_SELECT);
                if (hiddenInput) {
                    handleSelectChange(hiddenInput);
                }
            });
        });

        // Initialize switch fields
        var ajaxSwitches = document.querySelectorAll('.' + CSS_CLASSES.AJAX_SWITCH);
        ajaxSwitches.forEach(function(switchInput) {
            switchInput.addEventListener('change', function() {
                handleSwitchChange(this);
            });
        });
    }

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initPrivacyFields);
    } else {
        initPrivacyFields();
    }

})();
